import {
  ROUTE_PORTFOLIO_ANALYSIS,
  ROUTE_PORTFOLIO_DIVIDENDS,
  ROUTE_PORTFOLIO_HOLDINGS,
  ROUTE_PORTFOLIO_NARRATIVES,
  ROUTE_PORTFOLIO_RETURNS,
  ROUTE_PORTFOLIO_UPDATES,
} from '@/constants/routes';

export type PortfolioTab =
  | 'holdings'
  | 'analysis'
  | 'dividend'
  | 'narratives'
  | 'returns'
  | 'updates';

export const getRouteType = (tab: PortfolioTab) => {
  switch (tab) {
    case 'holdings':
      return ROUTE_PORTFOLIO_HOLDINGS;
    case 'narratives':
      return ROUTE_PORTFOLIO_NARRATIVES;
    case 'analysis':
      return ROUTE_PORTFOLIO_ANALYSIS;
    case 'dividend':
      return ROUTE_PORTFOLIO_DIVIDENDS;
    case 'returns':
      return ROUTE_PORTFOLIO_RETURNS;
    case 'updates':
      return ROUTE_PORTFOLIO_UPDATES;
  }
};
